var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppPageHeader',{attrs:{"text":"Uploads"}}),_c(_vm.displayComponent,{tag:"component",attrs:{"masterProposalID":_vm.mpEntity.getID(),"collectionMpUploads":_vm.documentCollection},on:{"refresh":_vm.refresh}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }